const { __, _x, _n, _nx, sprintf } = wp.i18n;

if (typeof $ == 'undefined') {
    $ = jQuery;
}

let notyf = null;

// jQuery.migrateDeduplicateWarnings = false;

// https://api.mixcloud.com/UMFradio/?metadata=1
jQuery(function($) {
    notyf = new Notyf({
        position: {
            x: 'center',
            y: 'top',
        },
        duration: 5000,
        dismissible: true,
        types: [
            {
                type: 'info',
                background: '#2244AA',
                icon: false
            },
            {
                type: 'warning',
                background: '#CCCC00',
                icon: false,
            },
            {
                type: 'error',
                duration: 0,
            }
        ]
    });

    runonce();
    rebuild();
    rebiza18();
});

function runonce() {
    countdown();
    appmode();
    buttons();
    mobile();
    resistance();
    resistanceEvents();
    rtus();
    tables();
    ls2018();
    setfilter();
    miamihotels();
    lightboxes();
    lineup();
    imagesLoaded();
    re2019();
    shwmodal();
    livestream2019();
    livestream2022();
    customreg();
    aboutPage();
    aboutPagev2();
    resistanceHome();

    setTimeout(function(){
        //$('article[data-regitem="south-africa-2020_ct"]').find('a.register').trigger('click');
        //$('.rgbtn').trigger('click');
    }, 500);

};

function rebuild() {
    forms();
    gallery();
    helpdesk();
    tickets();
    umfradio();
    //globalLiveStream();
    scroll2top();
    artists();
    contact();
    home();
    navigation();
    ajaxcontent();
    setTimeout(function() {
        hideWWbg();
    }, 100);
};


function createCookie(name, value, days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    } else {
        var expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}

var ddLogQueue = [];

function ddLog(message) {
    window.DD_LOGS.onReady(function () {
        window.DD_LOGS.logger.info(message);
    })
    log(message);
}

function getUrlParam(param, returnArray){
    var current_url = new URL(window.location);

    if (returnArray) {
        return current_url.searchParams.getAll(param);
    }
    return current_url.searchParams.get(param);
}